// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sk-0";
export var checkoutRateBadgeLink = "_sk-1";